import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
import { NavbarService } from '../_services/navbar.service';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { ProjectService } from '../_services/project.service';
import { ProjectDataForm } from '../_models/project-data-form';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
  selector: 'app-dashboard-user',
  templateUrl: './dashboard-user.component.html',
  styleUrls: ['./dashboard-user.component.css']
})
export class DashboardUserComponent implements OnInit {

  userDataSession;
  projectName: string = '';
  percentage;
  inventionPercentage = 0;
  drawingPercentage = 0;
  searchPercentage = 0;
  draftPercentage = 0;
  filingPercentage = 0;
  resumeType: number;
  projectList: ProjectDataForm[] = [];
  sessionObj;
  secondDesign = false;
  firstDesign = false;
  pointer = 'pointer';

  @ViewChild(NavbarComponent) navbarComponent: NavbarComponent;

  constructor(
    private authService: AuthService,
    private snotifyService: SnotifyService,
    private router: Router,
    private navbarService: NavbarService,
    private sesssionActivityService: SesssionActivityService,
    private projectService: ProjectService
  ) { }

  ngOnInit() {
    this.userDataSession = this.authService.getUserData();
    this.getProjectListByUserIDWitPer(this.userDataSession.userDetailsId)
    this.getLearningPercentageDetails(this.userDataSession.userDetailsId);
  }

  getProjectListByUserIDWitPer(userId) {
    this.projectService.getProjectListByUserIDWitPer(userId).subscribe(
      resp => {
        this.projectList = resp as ProjectDataForm[];
       // console.log(this.projectList);
      }, error => {
        console.log(error);
      })
  }

  getLearningPercentageDetails(id) {
    this.sesssionActivityService.getLastSessionActiityPercentageByUserId(id).subscribe(
      resp => {
        this.percentage = resp;
        this.inventionPercentage = this.percentage.inventionPercentage;
        this.drawingPercentage = this.percentage.drawingPercentage;
        this.searchPercentage = this.percentage.searchPercentage;
        this.draftPercentage = this.percentage.draftPercentage;
        this.filingPercentage = this.percentage.filingPercentage;
        if (this.percentage.inventionPercentage > 0) {
          this.secondDesign = false;
          this.firstDesign = true;
        } else {
          this.secondDesign = true;
          this.firstDesign = false;
        }
        if (this.percentage.inventionPercentage < 100) {
          this.resumeType = 1;
        } else if (this.percentage.drawingPercentage < 100) {
          this.resumeType = 2;
        } else if (this.percentage.searchPercentage < 100) {
          this.resumeType = 3;
        } else if (this.percentage.draftPercentage < 100) {
          this.resumeType = 4;
        } else if (this.percentage.filingPercentage <= 100) {
          this.resumeType = 5;
        }
      }, error => {
        this.snotifyService.error(error);
      })
  }

  goToLearningModule(type) {
    switch (type) {
      case (1):
        this.navbarService.saveActiveNavItem('Basics of Patents');
        this.router.navigate(['/main/learning/learnBasicOfPatents']);
        break
      case (2):
        if (this.percentage.inventionPercentage == 100) {
          this.navbarService.saveActiveNavItem('Patent Drawing');
          this.router.navigate(['/main/learning/learnPatentDrawing']);
        } else {
          alert("Please complete basic of patents");
        }
        break;
      case (3):
        if (this.percentage.drawingPercentage == 100) {
          this.navbarService.saveActiveNavItem('Patent Search');
          this.router.navigate(['/main/learning/learnPatentSearch']);
        } else {
          alert("Please complete patent drawing");
        }
        break;
      case (4):
        if (this.percentage.searchPercentage == 100) {
          this.navbarService.saveActiveNavItem('Patent Drafting');
          this.router.navigate(['/main/learning/learnPatentDraft']);
        } else {
          alert("Please complete patent search");
        }
        break;
      case (5):
        if (this.percentage.draftPercentage == 100) {
          this.navbarService.saveActiveNavItem('Patent Filing');
          this.router.navigate(['/main/learning/learnPatentFiling']);
        } else {
          alert("Please complete patent draft");
        }
        break;
      default:
        break;
    }
  }

  goModule(projectId) {
    this.sesssionActivityService.getProjectLastSessionActiityForRedirection(this.userDataSession.userDetailsId, 6, projectId).subscribe(
      resp => {
        this.sessionObj = resp;
        switch (this.sessionObj.activityType) {
          case 6:
            this.router.navigate(['/main/basicInventionDetails', projectId])
            break;
          case 7:
            this.router.navigate(['/main/patentDrawing', projectId])
            break;
          case 8:
            this.router.navigate(['/main/patentSearch', projectId])
            break;
          case 9:
          if(this.sessionObj.activityType == 9 && this.sessionObj.lastActivitySession == 17){
            this.router.navigate(['/main/preview', projectId])
          }else{
            this.router.navigate(['/main/patentDraft', projectId])
            
          }
            break;
          default:
            break;
        }
      }, error => {
        this.snotifyService.error(error);
      })
  }

}
